import React, { useContext } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

import Landing from "../../pages/LandingPage";
import Home from "../../pages/HomePage";
import Community from "../../pages/CommunityPage";
//import Signin from "../../pages/SigninPage";
//import Signup from "../../pages/SignupPage";
import Partner from "../../pages/PartnerPage";
import Worker from "../../pages/WorkerPage";
import Admin from "../../pages/AdminPage";
import Logs from "../../pages/community/LogsPage";
import GlobalContext from "../../state/GlobalContext";

import Toolbar from "@material-ui/core/Toolbar";
import logo from "../../assets/images/logo_transp.png";
import { AppBar, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

const NavBar = ({ classes }) => {
  return (
    <nav>
      <AppBar color="primary" position="fixed" className={classes.appBar}>
        <Toolbar>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <img alt="ooPark-community" className={classes.logo} src={logo} />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </nav>
  );
};

const Router = ({ classes }) => {
  const { session } = useContext(GlobalContext);
  const { isLoggedIn } = session.state;
  return (
    <BrowserRouter>
      <NavBar classes={classes} />
      <Switch>
        <Route path="/" exact>
          {isLoggedIn && session.state.user && (
            <PrivateRoute exact component={Home} path="/" />
          )}
          {!isLoggedIn && !session.state.user && (
            <PublicRoute exact component={Landing} path="/" />
          )}
        </Route>
        <PrivateRoute exact admin component={Admin} path="/admin" />
        <PrivateRoute exact community component={Community} path="/community" />
        <PrivateRoute exact community component={Logs} path="/logs" />
        <PrivateRoute exact worker component={Worker} path="/worker" />
        <PrivateRoute exact partner component={Partner} path="/partner" />
        {/*
            <PublicRoute exact component={Signin} path="/signin" />
            <PublicRoute exact component={Signup} path="/signup" />
          */}
      </Switch>
    </BrowserRouter>
  );
};

const styles = theme => ({
  main: {
    marginTop: 64,
    width: "100%"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  logo: {
    maxWidth: 200,
    maxHeight: 60,
    "&:hover": {
      cursor: "pointer"
    }
  }
});

export default withStyles(styles)(Router);
